/**
 * Note: This file has been written as a part of TNTEXP-32 which is a MVP-hack to support i18n
 * in HAMS<>JPY Stripe.
 */
import React, { createContext, useContext, useMemo } from 'react'; // TODO: Maybe type this in the future

var preferencesContext = /*#__PURE__*/createContext(undefined);

var useLanguagePreferences = function useLanguagePreferences() {
  var contextLanguages = useContext(preferencesContext);
  var languages = useMemo(function () {
    var _ref;

    return (_ref = contextLanguages !== null && contextLanguages !== void 0 ? contextLanguages : window.navigator.languages) !== null && _ref !== void 0 ? _ref : [window.navigator.language];
  }, [contextLanguages]);
  return languages;
};

export var LanguagePreferencesProvider = function LanguagePreferencesProvider(_ref2) {
  var children = _ref2.children,
      languages = _ref2.languages;
  return /*#__PURE__*/React.createElement(preferencesContext.Provider, {
    value: languages
  }, children);
};
export var isJapaneseLanguage = function isJapaneseLanguage(language) {
  return /^ja(\-.*)?$/i.test(language);
};
export var isEnglishLanguage = function isEnglishLanguage(language) {
  return /^en(\-.*)?$/i.test(language);
};
export var usePreferredLanguage = function usePreferredLanguage() {
  var languages = useLanguagePreferences();
  var language = useMemo(function () {
    return languages.find(function (language) {
      return isJapaneseLanguage(language) || isEnglishLanguage(language);
    });
  }, [languages]);
  return (language !== null && language !== void 0 ? language : 'en').toLowerCase();
};
export var I18nHack = function I18nHack(_ref3) {
  var ja = _ref3.ja,
      en = _ref3.en;
  var language = usePreferredLanguage();

  if (isJapaneseLanguage(language)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, ja);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, en);
};